export default __webpack_public_path__ + "static/media/Onboarding.ed6d5bc9.jpg";